import React from "react";
import { useDispatch } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/leadActivitySagas";

const FilterDropdown = ({
  options,
  selectedOption,
  width,
  index = null,
  title,
  keyName,
  isLoading,
  disabled,
  ...restProps
}) => {
  const dispatch = useDispatch();

  return (
    <div className="select-box" style={{ width }}>
      <p className="offers-title">{title}</p>
      {isLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <div className={disabled ? "disabled" : ""}>
          <MultiSelectDropdown
            options={options}
            selectedFilters={selectedOption}
            {...restProps}
            onSelectChange={(data) => {
              if (keyName !== "filter_by_values" && selectedOption.id === data.id) return;
              if (index == null) {
                return dispatch(actionCreators.updateMainFilter({ key: keyName, data }));
              }
              dispatch(actionCreators.updateFilterByIndex({ key: keyName, index, data }));
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
